import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import get from 'lodash/get';
import { showChangedToastMessage } from '@Containers/ToastMessages/ChangedToastMessage/ChangedToastMessageActions';
import {
  CURRENCY_TAB_ID,
  getPreferenceConfig,
  SHIPMENT_COUNTRY_TAB_ID,
  SHIPPING_TIME_TAB_ID,
} from '@Components/CommercialSubstancesPreferences/CommercialSubstancesPreferencesConstants';
import getTitleAndContentForToastMessage from './components/sections/PreferencesPreferredSuppliersSection/Components/PreferredSuppliersToastMessageUtils';

const NON_SUPPLIER_TOAST_GROUPS = [
  { tabId: CURRENCY_TAB_ID, noun: 'currency' },
  { tabId: SHIPMENT_COUNTRY_TAB_ID, noun: 'shipment country' },
  { tabId: SHIPPING_TIME_TAB_ID, noun: 'shipping time' },
];

const getCommercialToastGroups = (tabId) =>
  tabId ? NON_SUPPLIER_TOAST_GROUPS.filter((group) => group.tabId === tabId) : NON_SUPPLIER_TOAST_GROUPS;

const diffPreferences = (optionsMap = {}, originalCheckedMap = {}, checkedMap = {}) =>
  values(optionsMap).reduce(
    ({ added, deleted }, option) => {
      const { name } = option;
      if (!isUndefined(checkedMap[name]) && checkedMap[name] !== originalCheckedMap[name]) {
        return checkedMap[name] ? { added: added.concat(option), deleted } : { added, deleted: deleted.concat(option) };
      }
      return { added, deleted };
    },
    { added: [], deleted: [] }
  );

const showPreferencesChangedToast = ({ added, deleted, noun }) => {
  if (!isEmpty(added) || !isEmpty(deleted)) {
    const { title, content } = getTitleAndContentForToastMessage({ addedSuppliers: added, deletedSuppliers: deleted, noun });
    showChangedToastMessage({ title, content });
  }
};

export const showSupplierPreferencesChangedToastMessage =
  ({ optionsMap = {}, originalCheckedMap = {}, checkedMap = {} } = {}) =>
  () => {
    const { added: addedSuppliers, deleted: deletedSuppliers } = diffPreferences(optionsMap, originalCheckedMap, checkedMap);

    if (!isEmpty(addedSuppliers) || !isEmpty(deletedSuppliers)) {
      const { title, content } = getTitleAndContentForToastMessage({ addedSuppliers, deletedSuppliers });
      showChangedToastMessage({ title, content });
    }
  };

export const showCommercialSubstancesPreferencesChangedToastMessage =
  ({ combinedInfo = {}, originalUser = {}, editUser = {}, tabId } = {}) =>
  () => {
    getCommercialToastGroups(tabId).forEach(({ tabId: commercialPreferenceTabId, noun }) => {
      const { groupKey, preferenceKey } = getPreferenceConfig(commercialPreferenceTabId);
      const optionsMap = get(combinedInfo, [groupKey, 'preferences', preferenceKey, 'preferences'], {});
      const originalCheckedMap = get(originalUser, [groupKey, preferenceKey], {});
      const checkedMap = get(editUser, [groupKey, preferenceKey], {});
      const { added, deleted } = diffPreferences(optionsMap, originalCheckedMap, checkedMap);

      showPreferencesChangedToast({ added, deleted, noun });
    });
  };
